/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useTranslation } from 'next-i18next';
import styles from '@components/Radio/Radio.styles';
import { TProps } from '@components/Radio/typescript';
const Radio = ({
  active,
  value,
  onChange = () => undefined,
  children,
  addSx = {},
  name = '',
  showError = false,
  error = '',
  readonly,
  disabled,
  className = '',
  cy
}: TProps) => {
  const {
    t
  } = useTranslation('common');
  const onClick = () => {
    if (readonly || disabled) return;
    if (onChange) onChange(!active, value);
  };
  return <div sx={styles.radioWrapper} className={className} data-cy={cy}>
      <div className="radio-container" sx={{
      ...styles.radioContainer,
      ...addSx
    }} onClick={onClick}>
        <input type="radio" sx={styles.hiddenRadio} name={name} checked={active} readOnly value={value} />
        <span className="radio-checkmark" sx={styles.radioMarkContainer(active, showError)} />
        <label className="radio-label" htmlFor={name} sx={styles.radioLabel}>
          {children}
        </label>
      </div>
      <div className="radio-error" sx={styles.error(showError)}>
        {showError && t(`${error}`)}
      </div>
    </div>;
};
export default Radio;